import React, { useMemo, useState } from 'react';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import getLocal from 'eco-design-reliance/getLocal';
import EcoButton from 'eco-design/base/eco-button';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import { LangText } from './LangText';
import { EcoAccessoriesItemProps } from './index';

interface Props {
    item: EcoAccessoriesItemProps;
    onClickImgVideo?: (item: EcoAccessoriesItemProps) => void;
    idx: number;
}

const TabsBox: React.FC<Props> = ({ item, onClickImgVideo, idx }) => {
    const { locale = 'us' } = getLocal();
    const prefixCls = `eco-accessories`;
    const [active, setActive] = useState(0);

    const TextA = LangText[locale] || LangText['us'];

    const data = useMemo(() => item?.children?.[active] ?? {}, [item, active]);
    const { title, desc, price, noPrefix, comparePrice, inventoryQuantity, lChildren, pc, isVideo, priceSuffix, soldOut } = data;
    const soldOutBtn = Number(inventoryQuantity || 0) <= 0 ? soldOut || TextA.soldOut : lChildren || undefined;
    return (
        <>
            <div className={`${prefixCls}-item-tab`}>
                {item.children?.map((item, idx) => (
                    <div className={`${prefixCls}-item-tab-item ${active === idx ? 'active' : ''}`} onClick={() => setActive(idx)} key={idx}>
                        {item.tab}
                    </div>
                ))}
            </div>
            <div onClick={() => onClickImgVideo?.(data)}>
                <EcoImgVideo isVideo={isVideo} pc={pc} className={`${prefixCls}-item-img`} />
            </div>
            <div className={`${prefixCls}-item-msg`}>
                <div className={`${prefixCls}-item-title`}>{title}</div>
                <div className={`${prefixCls}-item-desc`}>{desc}</div>
                <div className={`${prefixCls}-item-price-box`}>
                    {price > 0 && (
                        <div className={`${prefixCls}-item-price-box-price`}>
                            {!noPrefix && TextA.priceMsA1} {FormatMoneyLocal(price, locale)}
                            {priceSuffix}
                        </div>
                    )}
                    {Number(comparePrice) > 0 && price !== comparePrice && price > 0 && (
                        <div className={`${prefixCls}-item-price-box-comparePrice`}>
                            {!noPrefix && TextA.priceMsB1} {FormatMoneyLocal(Number(comparePrice), locale)}
                        </div>
                    )}
                </div>
                <div className={`${prefixCls}-item-btn-box`}>
                    <EcoButton
                        lRadius="ellipse"
                        lSize="large"
                        lDataLayer={{
                            event: 'uaEvent',
                            event_name: 'buy',
                            product_name: item?.title,
                            position: `Product Detail_${idx}_${active + 1}`,
                        }}
                        {...data}
                        lChildren={soldOutBtn}
                    />
                </div>
            </div>
        </>
    );
};
export default TabsBox;
